import { Alert, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";

export const EmailConfirmationAlert = () => {
  return (
    <Alert className="border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-200">
      <Info className="h-4 w-4" />
      <AlertDescription>
        <strong>Email pendiente de confirmación:</strong> Revisa tu bandeja de entrada y confirma tu nueva dirección de email. 
        Algunas funciones pueden estar limitadas hasta que confirmes el cambio.
      </AlertDescription>
    </Alert>
  );
};